<template>
  <div>
    <!-- ÜSTTE: Mevcut kayıtlar (düzenlenebilir) -->
    <validation-observer ref="listForm">
      <div v-for="(row, i) in dataList" :key="row.id || i" class="mb-2">
        <b-row>
          <b-col>
            <BFormGroup label="Özellik Tanımı">
              <validation-provider #default="{ errors }" name="Özellik Tanımı">
                <b-form-input v-model="row.title" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </BFormGroup>
          </b-col>
          <b-col>
            <BFormGroup label="Değer">
              <cleave
                  v-model="row.value"
                  class="form-control"
                  :raw="false"
                  :options="options.text"
              />
            </BFormGroup>
          </b-col>
          <b-col cols="12" md="auto">
            <b-button variant="flat-success" class="btn-icon" title="Düzenle" @click="submitItem(row)">
              <feather-icon icon="PlusSquareIcon" style="width:18px;height:18px;" />
            </b-button>
            <b-button
                variant="flat-danger"
                class="btn-icon"
                @click="removeRow(i,row.id)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </b-col>
        </b-row>
        <hr />
      </div>
    </validation-observer>

    <!-- ALTA: Yeni kayıt ekleme formu -->
    <validation-observer ref="newItemForm">
      <b-row class="align-items-center">
        <b-col>
          <BFormGroup label="Özellik Tanımı">
            <validation-provider #default="{ errors }" name="Özellik Tanımı">
              <b-form-input 
                v-model="newItem.title" 
                list="default-properties"
                placeholder="Seçiniz veya yazın..."
              />
              <datalist id="default-properties">
                <option v-for="prop in defaultProperties" :key="prop" :value="prop" />
              </datalist>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </BFormGroup>
        </b-col>

        <b-col>
          <BFormGroup label="Değer">
            <cleave
                v-model="newItem.value"
                class="form-control"
                :raw="false"
                :options="options.text"
                placeholder="Giriniz.."
            />
          </BFormGroup>
        </b-col>

        <b-col cols="12" md="auto">
          <b-button variant="flat-success" class="btn-icon" title="Ekle" @click="submitNewItem">
            <feather-icon icon="PlusSquareIcon" style="width:18px;height:18px;" />
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <b-button 
            variant="outline-primary" 
            size="sm"
            @click="addAllDefaultProperties"
            :disabled="isAddingDefaults"
          >
            <feather-icon icon="PlusIcon" class="mr-1" />
            Tüm Default Özellikleri Ekle
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>

  </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BButton } from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider, localize } from 'vee-validate'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.tr'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {integer} from "@core/utils/validations/validations";

export default {
  name: 'ItemForm',
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    Cleave,
    BButton,
  },
  data() {
    return {
      options: { text: { delimiter: '', blocks: [255] } },
      defaultProperties: [
        'İŞVEREN',
        'BAŞLANGIÇ YILI',
        'BAŞLANGIÇ AY',
        'BİTİŞ YILI',
        'BİTİŞ AY',
        'PROJE SÜRESİ',
        'ARSA ALANI M2',
        'İNŞAAT ALANI M2',
        'PROJE BEDELİ USD',
        'PROJE BEDELİ EURO',
        'PROJE BEDELİ TL',
      ],
      isAddingDefaults: false,
    }
  },
  computed: {
    dataList: {
      get() {
        return this.$store.getters['productParameters/dataList']
      },
      set(val) {
        this.$store.commit('productParameters/SET_DATA_LIST', val)
      },
    },
    newItem: {
      get() {
        return this.$store.getters['productParameters/dataItem']
      },
      set(val) {
        this.$store.commit('productParameters/SET_DATA_ITEM', val)
      },
    },
  },
  async created() {
    await this.$store.dispatch('productParameters/getDataList',{
      where: {
        'product_parameters.id_products':this.$route.params.id,
      },
    })
    localize('tr')
  },
  methods: {
    async submitNewItem() {
      const ok = await this.$refs.newItemForm.validate()
      if (!ok) return
      const payload = {
        ...this.newItem,
        id_products: this.$route.params.id,
      }
      await this.$store.dispatch('productParameters/saveDataItem', payload)
      this.showToast({
        title: 'Başarılı!',
        icon: 'CheckIcon',
        text: 'Yeni özellik kaydedildi.',
        variant: 'success',
      })
      this.$store.dispatch('productParameters/getDataList',{
        where: {
          'product_parameters.id_products': this.$route.params.id,
        },
      })
    },
    async submitItem(data) {
      this.$refs.listForm.validate().then(success => {
        if (success) {
          // eslint-disable-next-line
          this.$store.dispatch('productParameters/saveDataItem',data)
          setTimeout(() => {
            this.$store.dispatch('productParameters/getDataList',{
              where: {
                'product_parameters.id_products': this.$route.params.id,
              },
            })
          }, 300)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },

    removeRow(i,id) {

      this.dataList.splice(i, 1)
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('productParameters/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    async addAllDefaultProperties() {
      this.isAddingDefaults = true
      const existingTitles = this.dataList.map(item => item.title?.toUpperCase().trim())
      
      for (const prop of this.defaultProperties) {
        // Eğer bu özellik zaten eklenmişse atla
        if (existingTitles.includes(prop.toUpperCase().trim())) {
          continue
        }
        
        const payload = {
          title: prop,
          value: '',
          id_products: this.$route.params.id,
        }
        
        try {
          await this.$store.dispatch('productParameters/saveDataItem', payload)
          // Kısa bir gecikme ekle ki backend'e çok hızlı istek gitmesin
          await new Promise(resolve => setTimeout(resolve, 100))
        } catch (error) {
          console.error(`Özellik eklenirken hata: ${prop}`, error)
        }
      }
      
      // Listeyi yenile
      await this.$store.dispatch('productParameters/getDataList', {
        where: {
          'product_parameters.id_products': this.$route.params.id,
        },
      })
      
      this.isAddingDefaults = false
      this.showToast({
        title: 'Başarılı!',
        icon: 'CheckIcon',
        text: 'Tüm default özellikler eklendi.',
        variant: 'success',
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: params,
      })
    },
  },
  props: {
    itemId:{
      type: integer,
      required:true
    }
  }
}
</script>
